// extracted by mini-css-extract-plugin
export default {"card":"QnOIkp","title":"Y6nYFG","openButton":"VjTgYh"};